import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { setAuthTokenGetter, setBaseUrl } from "@workspace/api-client-react";
import App from "./App.tsx";
import "./index.css";

// In production builds, point relative `/api/*` requests at the API host.
// VITE_API_BASE env var wins when set (per-environment overrides for staging,
// preview, AWS migration, etc.). Falls back to the hardcoded prod URL so the
// build works even when the host platform doesn't surface env vars to Vite.
// When unset AND in dev mode, Vite's proxy in vite.config.ts handles routing
// to http://localhost:8080 instead.
const PROD_API_BASE = "https://de2uveuyxp2cc.cloudfront.net";
const apiBase: string =
  import.meta.env.VITE_API_BASE ??
  (import.meta.env.PROD ? PROD_API_BASE : "");
if (apiBase.length > 0) {
  setBaseUrl(apiBase);
}

// Configure API client to use token from localStorage
setAuthTokenGetter(() => {
  return localStorage.getItem("crm_token");
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
